const routes = [
    {
        path: '/my-instructor-requests/:tab?',
        component: () => import('../pages/MyInstructorRequests.vue'),
        meta: {
            isAuthenticated: true,
            isStaff: true
        }
    },
    {
        path: '/grade/changes',
        component: () => import('../pages/Index.vue'),
        meta: {
            isAuthenticated: true,
            permission: "gradechange_index"
        }
    },
    {
        path: "/grade/change/:id",
        component: () => import("../pages/Detail.vue"),
        meta: {
            isAuthenticated: true,
            permission: "gradechange_show"
        }
    },
    {
        path: "/change-of-grade/request-form",
        component: () => import("../pages/InstructorForm.vue"),
        meta: {
            isAuthenticated: true,
            isStaff: true
        },
    },
];

export default routes;
